import React from "react";

const Withoutlayout = (props) => {
  return (
    <main
      style={{
        position: "relative",
        backgroundColor: props.theme === "dark" ? "#160F31" : "",
        minHeight: "100vh",
      }}
    >
      {props.main}
    </main>
  );
};

export default Withoutlayout;
